import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const stoptemplatespage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { StopsTemplatesPage } = await import(
        /* webpackChunkName: "StopsTemplatesPage" */ '../../../components/pages/private/StopsTemplatesPage'
      )
      return {
        default: StopsTemplatesPage,
      }
    })}
    exact
    key={paths.stopTemplatesPage}
    path={paths.stopTemplatesPage}
  />,
]
